/** 
 * Use as external script from public-api folder
 * requires jquery
 */

 import '../../../scss/booking-widget/v1/booking-widget.scss';
 import { init as init_token } from 'data/token';
 import { init as init_search } from 'booking-widget/v1/search';
 import { load_js } from 'utils/load';
 import { setup_ajax_triggers } from 'booking-widget/v1/common/util';
 
 (function ( $ ) {
     setup_ajax_triggers();

     $.fn.booking_widget = function(options) {
        if (typeof options === 'undefined') {
            options = {};
        }

        let el = this;
        let opts = $.extend({
            context_el: el,
            utc_offset: -10
        }, options);

        load_datepicker();

        $.when(init_token()).then(function() {
            // do whatever now
            init_search(opts);
        });

        return el;
    }

    $.fn.booking_widget_tour = function(options) {
        if (typeof options === 'undefined') {
            options = {};
        }

        // requires tour id
        if (!options.tour_id) {
            return this;
        }

        let el = this;
        let opts = $.extend({
            context_el: el,
            tour_id: 0,
            modal: true,
            open_on_click: el,
            utc_offset: -10
        }, options);

        load_datepicker();

        $.when(init_token()).then(function() {
            // do whatever now
             init_search(opts);
        });
        return el;
    }
 
     function load_datepicker() {
         // dynamically load daterangepicker so it's not flagged on pagespeed
         load_js({
             url: 'https://cdn.jsdelivr.net/momentjs/latest/moment.min.js',
             on_ready: function() {
                 load_js({
                     url: 'https://cdn.jsdelivr.net/npm/daterangepicker/daterangepicker.min.js',
                     on_ready: function() {
                         $(document).trigger('bw-daterangepicker-loaded');
                     }
                 })
             }
         });
 
     }
     
 }( jQuery ));